export default function (store) {
    const materials = Object.entries(store.state["Home/TrainingMaterial"] || {})
        .filter(([, material]) => material.IncludeInMatrix);

    const materialColumns = materials.map(([materialId, material]) => ({
        headerName: material.Title,
        type: "trainingStatus",
        field: `Materials_${materialId}`,
        materialId,
        minWidth: 80,
        width: 80,
        headerTooltip: material.Title,
        sortable: false,
        filter: false,
        metadata: {
            ...material
        }
    }));

    return {
        suppressHorizontalScroll: false,
        defaultColDef: {
            sortable: true,
            filter: true,
            resizable: true,
            cellDataType: false,
            suppressFieldDotNotation: false,
        },
        columnDefs: [{
            headerName: "Person",
            children: [{
                headerName: "Name",
                field: "name",
                pinned: "left",
                minWidth: 160,
            }, {
                headerName: "Department",
                field: "department",
                pinned: "left",
                minWidth: 120,
            }, {
                headerName: "Position",
                field: "job_title",
                pinned: "left",
                minWidth: 140,
            }]
        }, {
            headerName: "Training Materials",
            children: materialColumns
        }]
    };
}
